export default "__VITE_ASSET__0d07545f__"